module.exports = __webpack_public_path__ + "img/button_background.22d818f.png";